// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"54bb5762","857":"a7e0ab53","977":"dd5db45f"}[chunkId] + ".chunk.css";
};